const cardOne = {
  title: 'Get the investment property you want',
  subtitle: "We'll help you max your borrowing power.",
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-equity-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-equity-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-equity-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'More power to you',
      paragraph: <>Borrower friendly policies so you can borrow more, fast.</>,
    },
    {
      heading: 'Calculate fast',
      paragraph: <>See what you can borrow in 3 minutes.</>,
    },
    {
      heading: 'Workshop your numbers',
      paragraph: <>With an Investor Expert to see your maximum borrowing power.</>,
    },
  ],
};

const cardTwo = {
  title: 'Be ready to pounce at auction',
  subtitle: 'Get approved in days not weeks.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-bidready-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-bidready-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-bidready-modal-sm.png',
  },
  modalContent: [
    {
      heading: "Don't miss out.",
      paragraph: <>We&apos;ll get you pre-approved in days so you can get serious.</>,
    },
    {
      heading: 'Bid with confidence.',
      paragraph: <>Our pre-approval is more accurate because it&apos;s fully credit assessed.</>,
    },
    {
      heading: '90 day pre-approval',
      paragraph: <>Your season pass to house-hunting. If rates change, your borrowing power won&apos;t go down.</>,
    },
  ],
};

const cardThree = {
  title: (
    <>
      We save,
      <br />
      not sting
    </>
  ),
  subtitle: 'Loan options with no fees, no loyalty tax and a rate you can drop.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-sleepsoundly2-lg.jpg)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-sleepsoundly2-modal-lg.jpg',
    mobile: '/next-assets/carousel/cvp-sleepsoundly2-modal-sm.jpg',
  },
  modalContent: [
    {
      heading: 'Drop your own rate',
      paragraph: (
        <>
          With AcceleRATES, we&apos;ll drop your rate as you pay down your Straight Up or Power Up home loan
          <sup>2</sup>.
        </>
      ),
    },
    {
      heading: 'Loyalty is royalty',
      paragraph: (
        <>
          We always give existing and new customers the same awesome rates for like-for-like
          <sup>3</sup> loans with our Automatic Rate Match.
        </>
      ),
    },
    {
      heading: 'No Athena fees',
      paragraph: (
        <>
          Our Straight Up and Power Up loans have zero Athena fees
          <sup>1</sup>!
        </>
      ),
    },
  ],
};

const cardFour = {
  title: 'Loan structures for max returns',
  subtitle: 'With multi-offsets and splits.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-app-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-app-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-app-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Multi-splits',
      paragraph: (
        <>
          Split up to 10 loans against your property to optimise your loan structure and maximise your tax deductions.
        </>
      ),
    },
    {
      heading: 'Multi-offsets = multi benefits',
      paragraph: <>Stash your cash any way you want, create up to 10 offset sub-accounts.</>,
    },
    {
      heading: 'Cash-out in a snap',
      paragraph: <>Access equity and cash-out easily and quickly through our fast assessment process.</>,
    },
    {
      heading: 'Fee-free variations',
      paragraph: (
        <>
          Makes changes to your loan to suit your investment strategy. All changes to your Straight Up or Power Up loan
          are fee-free.
        </>
      ),
    },
  ],
};

export const carouselCardContent = [cardOne, cardTwo, cardThree, cardFour];
